import React, { useMemo } from 'react';

import { Input } from 'antd';

import { getMoment } from '@libs/NwMoment';

import CustomSelect from '@components/Gui/NwForm/CustomSelect';
import NwIcon from '@components/Gui/NwIcon';
import PeriodSelector from '@components/Gui/PeriodSelector';

import { useStatementContext } from '../StatementContext';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

/**
 * ReceivableNavigation
 *
 * Navigation bar for receivable statements (period, model filter, search)
 */
const ReceivableNavigation = ({
    onUpdateRange,
    onUpdatePeriod,
    modelList,
    modelFilter,
    setModelFilter,
    searchTerm,
    handleChangeSearchTerm,
    handleClearSearchTerm,
}) => {
    const { filters, alwaysEnabled } = useStatementContext();

    const rangeAsMoment = useMemo(() => {
        return [getMoment(filters.range[0]), getMoment(filters.range[1])];
    }, [filters.range]);

    return (
        <div className="statement-navigation">
            <PeriodSelector
                period={rangeAsMoment}
                onChange={onUpdateRange}
                alwaysEnabled={alwaysEnabled}
                defaultOption={filters.period}
                onChangePeriodOption={onUpdatePeriod}
            />
            {modelList.length > 0 && (
                <CustomSelect
                    style={{ maxWidth: '15rem' }}
                    options={[{ value: null, label: 'All models' }, ...modelList]}
                    value={modelFilter}
                    onChange={setModelFilter}
                />
            )}
            <div className="statement-search">
                <NwIcon icon={byPrefixAndName.fasl['search']} />
                <Input
                    autoComplete="off"
                    value={searchTerm}
                    placeholder="Search transactions"
                    onChange={handleChangeSearchTerm}
                    allowClear={{
                        clearIcon: (
                            <NwIcon icon={byPrefixAndName.fass['circle-xmark']} onClick={handleClearSearchTerm} />
                        ),
                    }}
                />
            </div>
        </div>
    );
};

export default ReceivableNavigation;

